import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { StateService } from '../services/state.service';

@Injectable({
  providedIn: 'root'
})
export class AccessGuard  {
  constructor(private state: StateService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {
      const hasAccess = (user: any, nextRoute: ActivatedRouteSnapshot) => {
        const accessRequired: string[] = nextRoute.data['accessRequired'] || [];
        const fallbackRoute: string = nextRoute.data['fallbackRoute'];
        for (const access of accessRequired) {
          if (user.accessKeys.indexOf(access) === -1) {
            if (fallbackRoute !== null && fallbackRoute !== undefined) {
              this.router.navigate([fallbackRoute]);
            }
            return false;
          }
        }
        return true;
      };

      if (this.state.user === undefined) {
        return this.state.getUserInfo().pipe(map((user => {
          if (!user) {
            this.router.navigate(['/']);
            return false;
          }
          return hasAccess(user, route);
        }),
        catchError(x => of(false))));
      }

      return of(hasAccess(this.state.user, route));
  }

}
